'use client';
import { useI18n } from '@locales/client';

import { WrapperBanner } from './styles';
import { BodyTextMediumC } from '@/shared/ui/typography2';
import { Button } from '@/shared/ui/form/button/button';
import { useConfirmDataPrompt } from '@/entities/data-confirmation/model/use-confirm-data-prompt';
import { useUserTelegram } from '@/shared/providers/user-provider/use-user';

const BannerPrompts = () => {
  const t = useI18n();
  const { showBanner, role, onPopupShow } = useConfirmDataPrompt();
  const telegram = useUserTelegram();

  if (!showBanner || telegram || role === 'player') return null;

  return (
    <WrapperBanner>
      <BodyTextMediumC>
        {t('account_verification.accountDataVerification')}
      </BodyTextMediumC>
      <div>
        <Button onClick={onPopupShow} variant="orangeGradient">
          <BodyTextMediumC>{t('account_verification.confirm')}</BodyTextMediumC>
        </Button>
      </div>
    </WrapperBanner>
  );
};

export { BannerPrompts };
